import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import useSiteSettings from './useSiteSettings';

const EditorialText = createContext([]);
export function EditorialTextProvider({children}) {
  const settings = useSiteSettings();
  const {pathname} = useLocation();
  const rules = (settings.text_replacements || []).filter(x => x.enabled !== false && (x.page === '*' || x.page === pathname));
  return <EditorialText.Provider value={rules}>{children}</EditorialText.Provider>;
}
export function useEditorialText(text) {
  const rules = useContext(EditorialText);
  const value = String(text ?? '');
  return rules.find(x => x.original?.trim() === value.trim())?.replacement ?? value;
}
